export default __webpack_public_path__ + "resources/icons/d131-44b9.png";